// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var Item = {
  $$default: {
    value: "",
    label: ""
  }
};

exports.Item = Item;
/* No side effect */
